import {
  CustomEvents,
  translations,
  CameraStates,
  game,
  modes,
  playersManager,
  trainingManager,
  hints,
  requestManager,
  audioManager,
  cameraManager
} from '@powerplay/core-minigames'
import {
  AudioGroups,
  AudioNames
} from '@/app/types'
import {
  loadingCircleState,
  loadingState,
  translations as t,
  tutorialCoreState
} from '@powerplay/core-minigames-ui'
import { hill } from '@/app/entities/hill/Hill'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'
import { translatesReplacements } from '@/app/config'
import {
  blurState,
  instructionsState,
  tableState,
  tournamentState,
  trainingResultsState,
  uiState
} from '@/stores'
import { disciplinePhasesManager } from '@/app/phases/DisciplinePhasesManager'
import { stateManager } from '@/app/StateManager'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initiateListeners = (vm: any) => {

  // Listener for language download

  window.addEventListener(CustomEvents.translations, () => {

    if (Number(import.meta.env.VITE_APP_LOCAL)) {

      translations.setTranslations(t, translatesReplacements)

    }
    vm.$i18n.setLocaleMessage('lang', translations.getTranslations())

    // musime zmenit hint v loadingu
    hints.setSpecificHintsCountForDiscipline(0)
    const hint = hints.getHintText(requestManager.disciplineID)

    loadingState().$patch({
      showLoading: true,
      hintText: vm.$t(hint)
    })

  })

  // Listener for game start event
  window.addEventListener(CustomEvents.gameStart, () => {

    if (!modes.isTutorial()) {

      loadingState().showLoading = false

    }

  })

  // Listener for game start instruction phase
  window.addEventListener(CustomEvents.startInstructionsPhase, () => {

    instructionsState().$patch({
      showInstructions: true,
      showButton: false
    })
    cameraManager.setState(CameraStates.table)
    cameraManager.playTween(true)
    game.renderScene()

  })

  // Listener pre tutorial Typewrite
  window.addEventListener(CustomEvents.typeWrite, () => {

    if (!modes.isTutorial()) return

    tutorialCoreState().typeWriter = false

  })

  // Listener pre tutorial game event
  window.addEventListener(CustomEvents.tutorialGameEvent, () => {

    if (!modes.isTutorial()) return

    tutorialFlow.checkInput()

  })

  // Listener for game intro start event
  window.addEventListener(CustomEvents.startIntroPhase, () => {

    audioManager.play(AudioNames.audienceNoise, undefined, undefined, 1)

    tableState().$patch({
      competitionText: modes.isTrainingMode() ?
        vm.$t('level').replace('%s', trainingManager.level) :
        `tableText${modes.mode}`,
      showTable: true
    })

    if (!modes.isTutorial() && !modes.isTrainingMode()) {

      audioManager.stopAudioByGroup(AudioGroups.commentators)
      audioManager.play(AudioNames.commentIntro)

    }

  })

  // Listener for game start listing phase
  window.addEventListener(CustomEvents.startStartListPhase, () => {

    blurState().$patch({
      isActive: true,
      isTable: true
    })

    const data = playersManager.getDataForTable()
    console.log(data)
    tableState().$patch({
      dataTable: data,
      resultText: 'startList',
      isStartList: true,
      activeState: true
    })

  })

  // Listener for game start discipline phase
  window.addEventListener(CustomEvents.startDisciplinePhase, () => {

    blurState().$patch({
      isActive: false,
      isTable: false
    })

    tableState().$patch({
      showTable: false,
      activeState: false,
      isStartList: false
    })

  })

  // Listener for game start provisional results phase
  window.addEventListener(CustomEvents.startProvisionalResultsPhase, () => {

    blurState().$patch({
      isActive: true,
      isTable: true
    })

    stateManager.editTournamentDefaultValuesFromServer()

    playersManager.setStandings(3, modes.isTournament(), modes.isTournament())

    const dataStandings = playersManager.getStandings()
    console.log(dataStandings)
    // musime si zaznacit najlepsi vysledok, aby sme to potom mohli zobrazit
    tournamentState().bestResult = dataStandings[0].result ?? '-'
    if (tournamentState().bestResult === '') tournamentState().bestResult = '-'

    tableState().$patch({
      dataTable: dataStandings,
      resultText: 'provisionalResults',
      showTable: true,
      activeState: true
    })

    hill.setVisibilityOfAllTrackParts(true)

  })

  // Listener for game start final standings phase
  window.addEventListener(CustomEvents.startFinalStandingsPhase, () => {

    uiState().showFinishTopBox = false

    audioManager.stopAudioByName(AudioNames.ride)
    audioManager.stopAudioByName(AudioNames.rideCurves)
    audioManager.stopAudioByName(AudioNames.break)
    audioManager.stopAllAudio()
    audioManager.play(AudioNames.audienceNoise, undefined, undefined, 1)
    audioManager.play(AudioNames.commentFinalResults)

    hill.setVisibilityOfAllTrackParts(true)

    if (modes.isTournament() && !disciplinePhasesManager.tournamentDataSet) return

    blurState().$patch({
      isActive: true,
      isTable: true
    })

    if (modes.isTournament()) {

      stateManager.editTournamentDefaultValuesFromServer()
      playersManager.setStandings(3)

    }

    tableState().$patch({
      competitionText: modes.isTrainingMode() ?
        vm.$t('level').replace('%s', trainingManager.level) :
        `tableText${modes.mode}`,
      dataTable: playersManager.getStandings(),
      resultText: modes.isTournament() || modes.isDailyLeague() ? 'provisionalResults' : 'finalStandings',
      showTable: !modes.isTutorial(),
      activeState: true
    })

  })

  // Listener for game start final training phase
  window.addEventListener(CustomEvents.startFinalTrainingPhase, () => {

    if (modes.isTutorial()) return
    trainingResultsState().showResults = true

    audioManager.stopAllAudio()
    audioManager.play(AudioNames.audienceNoise, undefined, undefined, 1)

    hill.setVisibilityOfAllTrackParts(true)

  })

  // Listener pre to, aby sme vedeli, ze su vsetky konecne requesty zbehnute
  window.addEventListener(CustomEvents.allRequestDoneOnEnd, () => {

    if (modes.isTournament() && Number(import.meta.env.VITE_APP_LOCAL) === 1) return

    stateManager.afterAllRequestsDone()

  })

  /** Listener pre zobrazenie loading circle po kliknuti na final redirect */
  window.addEventListener(CustomEvents.finalRedirectDone, () => {

    loadingCircleState().isActive = true

  })

}
